// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2pBZp","actions":"GroupTable_actions__jaPGI","deleteModalFooter":"GroupTable_deleteModalFooter__2qtY1"};